import { WorldMapProps } from "@definitions/types"
import SvgGermany from "public/svg/map/germany.svg"
import SvgKenya from "public/svg/map/kenya.svg"
import SvgLebanon from "public/svg/map/lebanon.svg"
import SvgMalaysia from "public/svg/map/malaysia.svg"
import SvgNigeria from "public/svg/map/nigeria.svg"
import SvgOman from "public/svg/map/oman.svg"
import SvgQatar from "public/svg/map/qatar.svg"
import SvgSaudi from "public/svg/map/saudi.svg"
import SvgUAE from "public/svg/map/uae.svg"

export const Countries: WorldMapProps[] = [
  {
    title: "UAE",
    svg: SvgUAE,
  },
  {
    title: "Saudi Arabia",
    svg: SvgSaudi,
  },
  {
    title: "Kenya",
    svg: SvgKenya,
  },
  {
    title: "Qatar",
    svg: SvgQatar,
  },
  {
    title: "Oman",
    svg: SvgOman,
  },
  {
    title: "Lebanon",
    svg: SvgLebanon,
  },
  {
    title: "Germany",
    svg: SvgGermany,
  },
  {
    title: "Malaysia",
    svg: SvgMalaysia,
  },
  {
    title: "Nigeria",
    svg: SvgNigeria,
  },
]
